import { SUBSCRIPTION_STATE } from 'hooks/useSubscriptionsState';
import { IProductModel } from 'components/Cart/models';

export const getPriceAndTranslationString = (
  t: any,
  payMonthly: boolean,
  subscriptionsState: SUBSCRIPTION_STATE,
  product?: IProductModel,
) => {
  if (!product) return '';

  const is36MonthsEnabled = subscriptionsState === SUBSCRIPTION_STATE.ENABLED_36_MONTH;
  const { quantity, installmentPlans, totalCost } = product;

  const actualQuantity = quantity ?? 1;
  const cartProductTotalCost = totalCost ? totalCost * actualQuantity : 0;

  const sl36Value = installmentPlans?.SL36?.value;
  const sl48Value = installmentPlans?.SL48?.value;

  const sl36Pricing = sl36Value ? sl36Value * actualQuantity : 0;
  const sl48Pricing = sl48Value ? sl48Value * actualQuantity : 0;

  const hasSubscriptionPricing = sl36Pricing || sl48Pricing;

  if (!payMonthly || !hasSubscriptionPricing) {
    return t('cart-page.item-cost', { price: cartProductTotalCost });
  }

  return t('cart-page.monthly-price', { price: is36MonthsEnabled ? sl36Pricing : sl48Pricing });
};
